export const _setUnViewed = (state, action) => {
  state.unViewed = action.payload;
};
